import React from 'react';
import { withStyles } from '@mui/styles';
import Checkbox from '@mui/material/Checkbox';


const PrimaryCheckbox = withStyles({
    root: {
        // color: "#06e241",
        '&$checked': {
            color: "#fd8c00",
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

export default PrimaryCheckbox;